module.exports = __webpack_public_path__ + "static/media/sign-note-white.29f685d3.svg";